/** @file bookings/workflow.js — status transitions + activity log. */
import { supabase } from "@/lib/supabaseClient";

export async function transitionBooking({
  bookingId,
  fromStatus,
  toStatus,
  reason = null,
}) {
  void fromStatus;
  const patch = { status: toStatus };
  if (reason !== null && reason !== "") patch.rejection_reason = reason;

  const { data, error } = await supabase
    .from("lbs_bookings")
    .update(patch)
    .eq("id", bookingId)
    .select()
    .maybeSingle();

  return { data, error };
}

export async function listBookingActivity(bookingId) {
  return supabase
    .from("lbs_audit_log")
    .select("id,action,old_values,new_values,created_at,user_id,user:lbs_user_profiles!lbs_audit_log_user_id_fkey(first_name,last_name,email)")
    .eq("entity_type", "booking")
    .eq("entity_id", bookingId)
    .order("created_at", { ascending: false })
    .limit(100);
}

/* =================  DOCK MANAGER GRID  =================== */
